import React, { createContext, useContext, useState, useEffect } from "react";
import { auth } from "../lib/api";

const AuthContext = createContext(null);
const OUTRAS_EMPRESAS_EMAILS = new Set(["admin@teste.com", "vendas@wellpec.com.br"]);
const PETRONECT_EMAILS = new Set(["admin@teste.com", "vendas@wellpec.com.br"]);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      auth.me()
        .then((response) => {
          setUser(response.data);
          localStorage.setItem("user", JSON.stringify(response.data));
        })
        .catch(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, senha) => {
    const response = await auth.login({ email, senha });
    const { access_token, user: userData } = response.data;
    
    localStorage.setItem("token", access_token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  const isAdmin = () => {
    return user?.perfil === "administrador";
  };

  const canAccessOutrasEmpresas = () => {
    return OUTRAS_EMPRESAS_EMAILS.has(user?.email?.trim().toLowerCase());
  };

  const canViewPetronect = () => PETRONECT_EMAILS.has(user?.email?.trim().toLowerCase());
  const canAdminPetronect = () => user?.email?.trim().toLowerCase() === "admin@teste.com";

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, canAccessOutrasEmpresas, canViewPetronect, canAdminPetronect }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
